module.exports = __webpack_public_path__ + "static/media/Sky.921c456d.jpg";